import { HEBREW_MONTHS_EN } from '../constants/metadata';
import { parseDateKey, toJerusalemDateKey } from '../utils/date';
import { fetchJson } from './network';

const HEBREW_MONTH_INDEX = HEBREW_MONTHS_EN.reduce((acc, monthName, index) => {
  acc[monthName] = index + 1;
  return acc;
}, {});

function dayKey(date) {
  return toJerusalemDateKey(date);
}

function mapHebcalRangeRow(row) {
  const monthValue = typeof row.hm === 'number' ? row.hm : HEBREW_MONTH_INDEX[row.hm] || null;

  return {
    d: Number(row.hd),
    m: monthValue,
    y: Number(row.hy)
  };
}

async function georgianToJewishByDate(date, signal) {
  const parts = parseDateKey(dayKey(date));
  const json = await fetchJson(
    `https://www.hebcal.com/converter?cfg=json&gy=${parts.year}&gm=${parts.month}&gd=${parts.day}&g2h=1`,
    { signal }
  );

  return {
    d: Number(json.hd),
    m: HEBREW_MONTH_INDEX[json.hm] || null,
    y: Number(json.hy)
  };
}

export async function getJewishDatesForRange(dates, { signal } = {}) {
  if (!dates.length) {
    return [];
  }

  const start = dayKey(dates[0]);
  const end = dayKey(dates[dates.length - 1]);

  try {
    const json = await fetchJson(
      `https://www.hebcal.com/converter?cfg=json&start=${start}&end=${end}&g2h=1`,
      { signal }
    );

    const range =
      (Array.isArray(json) && json) ||
      (Array.isArray(json.range) && json.range) ||
      (Array.isArray(json.hdates) && json.hdates) ||
      (Array.isArray(json.items) && json.items) ||
      [];

    if (!range.length) {
      throw new Error('Unsupported Hebrew date range response');
    }

    const byDate = new Map();
    range.forEach((row) => {
      const hasGregorianDate = row.gy && row.gm && row.gd;
      const dateValue = row.date
        ? row.date
        : hasGregorianDate
          ? `${row.gy}-${String(row.gm).padStart(2, '0')}-${String(row.gd).padStart(2, '0')}`
          : '';

      if (dateValue) {
        byDate.set(dateValue, mapHebcalRangeRow(row));
      }
    });

    const mapped = dates.map((date) => byDate.get(dayKey(date)) || null);

    if (mapped.some((entry) => !entry || !entry.m)) {
      throw new Error('Missing Hebrew date rows in range response');
    }

    return mapped;
  } catch (error) {
    return Promise.all(dates.map((date) => georgianToJewishByDate(date, signal)));
  }
}

export async function getHebcalItemsByYear(year, { signal } = {}) {
  const json = await fetchJson(
    `https://www.hebcal.com/hebcal?v=1&cfg=json&lg=h&geo=geoname&geonameid=293825&year=${year}&month=x&maj=on&min=on&mod=on&s=on&ss=on&nx=on&mf=on&b=30&m=40&c=on&d=on&o=on&i=on`,
    { signal }
  );
  return Array.isArray(json.items) ? json.items : [];
}
